<template>
  <el-tabs v-model="activeName" class="page-property">
    <el-tab-pane :label="$lang.configurationEditor.layoutAndStyle" name="layout">
      <LayoutConfig/>
    </el-tab-pane>
    <el-tab-pane :label="$lang.configurationEditor.node" name="nodeList">
      <ComponentsConfig show-active/>
    </el-tab-pane>
  </el-tabs>
</template>
<script>
import LayoutConfig from "./LayoutConfig";
import ComponentsConfig from "../ComponentsConfig";
export default {
  name: "MultiComponentsProperty",
  components: {ComponentsConfig, LayoutConfig},
  
  data() {
    return {
      activeName: 'layout'
    }
  }
}
</script>
<style scoped lang="scss">
.page-property {
  
  ::v-deep {
    > .el-tabs__header {
      margin: 0;
      
      .el-tabs__nav {
        .el-tabs__item {
          padding: 0 8px;
        }
      }
    }
    
    > .el-tabs__content {
      height: calc(100% - 40px);
      
      > .el-tab-pane {
        height: 100%;
        
        > .el-scrollbar {
          height: 100%;
          
          > .el-scrollbar__wrap {
            overflow-x: auto;
          }
        }
      }
    }
  }
}
</style>